// Alias
import DefaultSectionDivider from '../../section-divider';
export default DefaultSectionDivider;
//# sourceMappingURL=index.js.map